

import { ref } from 'vue'
import VueDraggableResizable from 'vue-draggable-resizable'

import AccountBox from 'vue-material-design-icons/AccountBoxOutline.vue'

import { t, isRTL } from '@nextcloud/l10n'

import NcButton from '@nextcloud/vue/components/NcButton'

import LocalVideo from './LocalVideo.vue'
import VideoVue from './VideoVue.vue'

const isDirectionRTL = isRTL()

export default {
	name: 'PresenterOverlay',

	components: {
		AccountBox,
		VueDraggableResizable,
		NcButton,
		LocalVideo,
		VideoVue,
	},

	props: {
		token: {
			type: String,
			required: true,
		},

		model: {
			type: Object,
			required: true,
		},

		sharedData: {
			type: Object,
			required: true,
		},

		isCollapsed: {
			type: Boolean,
			required: true,
		},

		isLocalPresenter: {
			type: Boolean,
			default: false,
		},

		localMediaModel: {
			type: Object,
			default: null,
		},
	},

	emits: ['click'],

	setup() {
		const parentWidth = ref(document.getElementById('videos').getBoundingClientRect().width)
		return {
			parentWidth,
			isDirectionRTL,
		}
	},

	data() {
		return {
			resizeObserver: null,
			presenterOverlaySize: 128,
			isDragging: false,
		}
	},

	mounted() {
		this.resizeObserver = new ResizeObserver(this.updateSize)
		this.resizeObserver.observe(this.$refs.presenterOverlay.$el.parentElement)
	},

	beforeDestroy() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect()
		}
	},

	methods: {
		t,
		updateSize() {
			// Size should be proportionate to the screen share size
			const newSize = Math.round(this.$refs.presenterOverlay.$el.parentElement.clientWidth * 0.1)
			this.presenterOverlaySize = Math.min(Math.max(newSize, 100), 242)
			// FIXME: inner method should be triggered to re-parent element
			this.$refs.presenterOverlay.checkParentSize()
			// FIXME: if it stays out of bounds (right and bottom), bring it back
			// FIXME: should consider RTL
			if (this.$refs.presenterOverlay.right < 0 && this.$refs.presenterOverlay.parentWidth > this.presenterOverlaySize) {
				this.$refs.presenterOverlay.moveHorizontally(this.$refs.presenterOverlay.parentWidth - this.presenterOverlaySize)
			}
			if (this.$refs.presenterOverlay.bottom < 0 && this.$refs.presenterOverlay.parentHeight > this.presenterOverlaySize) {
				this.$refs.presenterOverlay.moveVertically(this.$refs.presenterOverlay.parentHeight - this.presenterOverlaySize)
			}
		},
	},
}
